// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loadingScreen-module__loadingWrapper___10m9N","loadingItem":"loadingScreen-module__loadingItem___2AlOn"};